import { ChangeDetectorRef, Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { OfferSignatureRequested } from '../../../models/offer-signature-requested';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { findSignatureRequestAct, updateSignatureRequestedAct } from '../../../store/signature-requested/signature-requested.actions';
import { distinctUntilChanged, map } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-review-requested-signatures',
  standalone: false,
  templateUrl: './review-requested-signatures.component.html',
  styleUrl: './review-requested-signatures.component.css',
  providers: [provideNativeDateAdapter()]
})
export class ReviewRequestedSignaturesComponent {

  violations: any;
  requestSignatureForm!: NgForm;
  loading: boolean = false;
  offerSignatureRequested: OfferSignatureRequested = new OfferSignatureRequested();
  //pdfSrc?: SafeResourceUrl;
  pdfSrc: Uint8Array | null = null;
  signatureSol: boolean = false;
  isInTypeOffer!: boolean;

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.offerSignatureRequestedStore.dispatch(findSignatureRequestAct({ id }));
      }else{
        this.offerSignatureRequested = new OfferSignatureRequested();
      }
    });
  }

  constructor(
    private offerSignatureRequestedStore: Store<{offerSigReqRdc: any}>,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    //private sanitizer: DomSanitizer
  ){
    this.offerSignatureRequested = new OfferSignatureRequested();

    this.offerSignatureRequestedStore.pipe(
        select('offerSigReqRdc'),
        map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
          signatureRequested: state.signatureRequested,
          violations: state.violations,
          loading: state.loading
        })),
        // evita repeticiones
        distinctUntilChanged((prev, curr) =>
          JSON.stringify(prev) === JSON.stringify(curr)
        )
      ).subscribe(({ signatureRequested, violations, loading }) => {
      this.violations = violations;
      this.offerSignatureRequested = JSON.parse(JSON.stringify(signatureRequested)); // o mejor: _.cloneDeep(offer)
      this.signatureSol = this.offerSignatureRequested.status.code === "SOL"? true : false;

      const binary = atob(this.offerSignatureRequested.offerPdf ?? "");
      const len = binary.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
      }

      this.pdfSrc = bytes; // ahora es un Uint8Array válido

      /*this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        `data:application/pdf;base64,${this.offerSignatureRequested.offerPdf}`
      );*/

      this.loading = loading;
      this.cd.markForCheck(); // fuerza la actualización de la vista
      //console.log("cargando " + this.loading);

      if(this.offerSignatureRequested.offer!.typeOffer == 'IN'){
        this.isInTypeOffer = true;
      }else{
        this.isInTypeOffer = false;
      }

      if(this.requestSignatureForm){
        for (const controlName in this.requestSignatureForm.controls) {
          if (this.requestSignatureForm.controls.hasOwnProperty(controlName)) {
            const control = this.requestSignatureForm.controls[controlName];
            if(this.violations[controlName]){
              control.setErrors({'incorrect': true});
            }
          }
        }
      }
    });
  }

  onSubmitReviewRequestSignature(requestSignatureForm: NgForm): void {
    this.requestSignatureForm = requestSignatureForm;

    this.offerSignatureRequested.offerPdf = "";
    this.offerSignatureRequestedStore.dispatch(updateSignatureRequestedAct({ signatureRequestedUpdated: this.offerSignatureRequested }));
  }
}
